import { render, staticRenderFns } from "./15.vue?vue&type=template&id=5a828edc&scoped=true&"
var script = {}
import style0 from "./15.vue?vue&type=style&index=0&id=5a828edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a828edc",
  null
  
)

export default component.exports